import { attributeValue } from "func-xml";
import { curry } from "ramda";
import nodeId from "../nodeId";
import { ATTR_FV_DS, ATTR_FV_ID } from "./view.attribute.names";


export const hasYesAttributeJq = curry(
    (attributeName, jQElement) => jQElement.attr(attributeName) === 'yes'
);

export const getNodeId = (el) => {
    const id = attributeValue(ATTR_FV_ID)(el);
    const ds = attributeValue(ATTR_FV_DS)(el);

    if (!id) {
        return null;
    }

    return nodeId(id, ds);
};